import React from "react";
import Page from "components/Page";
import { Props } from "./Settings";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Settings = lazyWithRetry(() => import("./Settings"));

export default (props: Props) => (
  <Page>
    <Settings {...props} />
  </Page>
);
